import React from "react";
import { iMate, Teammate } from "../composites/Teammate";

import Atarev from "../../resources/images/Team/Atarev.png";
import Stinky from "../../resources/images/Team/SuperStinky3.gif";
import DreadPirateDB from "../../resources/images/Team/Dread_Pirate_Drool_Beard.png";
import Monke from "../../resources/images/Team/CEO-Of-Monke.png";
import { Socials } from "../composites/Socials";

const ceoOfMonke: iMate = { 
  image: Monke, 
  title: "CEO Of Monke", 
  twitter: "@ceoofmonke64",
  description: "Artist \n& Content Creator"
};

const atarev: iMate = { 
  image: Atarev, 
  title: "Atarev", 
  twitter: "@atarevcrypto",
  description: "IT Department, \nMusic, \n& Content Creator"
};

const stinky: iMate = { 
  image: Stinky, 
  title: "Stinky", 
  twitter: "@nomamesgwei",
  description: "Solidity Dev, \nVideo Editor, \n& Marketing"
};

const dreadPirateDB: iMate = { 
  image: DreadPirateDB, 
  title: "Dread Pirate Drool Beard", 
  twitter: "@DreadPirateDB",
  description: "React Dev \n& Content Creator"
};

export class Team extends React.Component {
  
  render(): React.ReactElement {
    return(
      <div className="team-page">
        <div className="main">
        <Teammate mate={ceoOfMonke} />
        <Teammate mate={atarev} />
        <Teammate mate={stinky} />
        <Teammate mate={dreadPirateDB} />
        </div>
        
        <div className="team-footer" >
          <div className="company">
            Twisted Tech
          </div>
          <Socials />
        </div>
      </div>
    )
  }
}